import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

const MIN_TEXT_INPUT_CHARACTERS = 2;
const MAX_TEXT_INPUT_CHARACTERS = 56;

export function useTextInputOptionalValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();
  return Yup.string()
    .nullable()
    .max(
      MAX_TEXT_INPUT_CHARACTERS,
      getMessage(
        "Validation.message-maxLengthCharacters",
        MAX_TEXT_INPUT_CHARACTERS,
      ),
    );
}

export function useTextInputValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();
  return Yup.string()
    .nullable()
    .min(
      MIN_TEXT_INPUT_CHARACTERS,
      getMessage(
        "Validation.message-minLengthCharacters",
        MIN_TEXT_INPUT_CHARACTERS,
      ),
    )
    .max(
      MAX_TEXT_INPUT_CHARACTERS,
      getMessage(
        "Validation.message-maxLengthCharacters",
        MAX_TEXT_INPUT_CHARACTERS,
      ),
    )
    .required(getMessage("Validation.message-required"));
}
